<!-- =========================================================================================
    File Name: PaginationDefault.vue
    Description: Rendering of default pagination
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="mt-1 w-full no-overflow">
    <vs-pagination :total="totalLenght" v-model="currentx"></vs-pagination>
  </div>
</template>

<script>
  export default {
    props: {
      totalLenght: {
        type: Number
      },
      setCurrentPage: {
        type: Number
      }
    },
    data: () => ({
      //currentx : 1
    }),
    watch: {
      totalLenght: function (val) {
        (this.currentx > val) ? this.currentx = 1 : "";
      },
    },
    computed:{
      currentx: {
        get() {
          return this.setCurrentPage+1;
        },
        set(val) {
          if (val) {
            this.$emit("currentPage",val);
          }
        }
      }
    }
  }

</script>
